import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SmsLineAccountService {

    constructor(private api: ApiService) { }

    getLinesAccount(criteria: Object = {}): Observable<any> {
        return this.api.get('vna/sms/line-account', criteria);
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/sms/services/sms-line-account.service.ts